import { render, staticRenderFns } from "./MetaDataCategoryIndex.vue?vue&type=template&id=32834e8b&"
import script from "./MetaDataCategoryIndex.vue?vue&type=script&lang=js&"
export * from "./MetaDataCategoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports